import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";

interface CollapsibleTopsFilterProps {
  collection: { handle: string; title: string; id: string };
  selectedCategory: string | undefined;
  selectedTopsSubCategories: string[];
  showTopsSubCategories: boolean;
  onCategoryChange: (handle: string) => void;
  onSubCategoryChange: (subCategories: string[]) => void;
  onToggleExpansion: (expanded: boolean) => void;
  onPageChange: (page: number) => void;
}

const CollapsibleTopsFilter: React.FC<CollapsibleTopsFilterProps> = ({
  collection,
  selectedCategory,
  selectedTopsSubCategories,
  showTopsSubCategories,
  onCategoryChange,
  onSubCategoryChange,
  onToggleExpansion,
  onPageChange,
}) => {
  const topsSubCategories = [
    'Blouses', 'Button-Up', 'Camis', 'Cardigans', 'Hoodies', 
    'Jackets', 'Kimonos', 'Mesh', 'Sweaters', 'T-Shirts', 'Tanks'
  ];

  const handleSubCategoryToggle = (subCategory: string, checked: boolean) => {
    if (checked) {
      onSubCategoryChange([...selectedTopsSubCategories, subCategory]);
    } else {
      onSubCategoryChange(selectedTopsSubCategories.filter(cat => cat !== subCategory));
    }
  };

  return (
    <div>
      <Collapsible open={showTopsSubCategories} onOpenChange={onToggleExpansion}>
        <CollapsibleTrigger asChild>
          <label htmlFor={`radio-${collection.handle}`} className="flex items-center space-x-2 cursor-pointer">
            <input
              id={`radio-${collection.handle}`}
              type="radio"
              name="collection"
              checked={selectedCategory === collection.handle}
              onChange={() => {
                onCategoryChange(collection.handle);
                onPageChange(1);
                onToggleExpansion(true);
              }}
              className="w-4 h-4 accent-primary bg-background border-border focus:ring-primary focus:ring-2"
            />
            <span className="text-sm text-muted-foreground/50">{collection.title}</span>
            <ChevronDown 
              className={`w-3 h-3 transition-transform ${showTopsSubCategories ? 'rotate-180' : ''}`} 
            />
          </label>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <div className="ml-6 mt-2 space-y-1">
            {topsSubCategories.map(subCategory => (
              <label key={subCategory} htmlFor={`checkbox-tops-${subCategory.replace(/\s+/g, '-').toLowerCase()}`} className="flex items-center space-x-2 cursor-pointer">
                <input
                  id={`checkbox-tops-${subCategory.replace(/\s+/g, '-').toLowerCase()}`}
                  type="checkbox"
                  checked={selectedTopsSubCategories.includes(subCategory)}
                  onChange={(e) => handleSubCategoryToggle(subCategory, e.target.checked)}
                  className="w-3 h-3 accent-primary bg-background border-border focus:ring-primary focus:ring-1 rounded"
                />
                <span className="text-xs text-muted-foreground">{subCategory}</span>
              </label>
            ))}
          </div>
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
};

export default CollapsibleTopsFilter;